import { render, staticRenderFns } from "./invoicingManagementAddEdit.vue?vue&type=template&id=bfb2aacc&scoped=true"
import script from "./invoicingManagementAddEdit.vue?vue&type=script&lang=js"
export * from "./invoicingManagementAddEdit.vue?vue&type=script&lang=js"
import style0 from "./invoicingManagementAddEdit.vue?vue&type=style&index=0&id=bfb2aacc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb2aacc",
  null
  
)

export default component.exports